// extracted by mini-css-extract-plugin
export default {"wrapper":"a3","new_badge":"b3","flavorContainer":"c3","product_tile":"e3","img":"f3"};
    if(module.hot) {
      // 1714442371670
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  